<template>
    <div class="teacher teacher-item" @click="authorClick(author, $event)">
        <img class="teacher-item-foto" :src="`${author.photo}`" :alt="author.author">
        <div class="teacher-item-name">{{ author.author }}</div>
        <div class="text-center teacher-description">{{ descriptionTrancated }}</div>
    </div>
</template>

<script>
    export default {
        name: "AuthorGalleryItem",

        props: {
            author: Object
        },

        computed: {
            descriptionTrancated() {
                return this.truncateString(this.author.description, 250);
            },
        },

        methods: {
            authorClick(author, event) {
                console.log('click AutorGalleryItem author', author)
                this.$emit('authorClick', author, event)
            },

            truncateString(str, num) {
                // If the length of str is less than or equal to num
                // just return str--don't truncate it.
                if (str.length <= num) {
                    return str
                }
                // Return str truncated with '...' concatenated to the end of str.
                return str.slice(0, num) + '...'
            }
        }

    }
</script>

<style>
    .teacher-item {
        cursor: pointer;
    }

    .teacher-item-name {
        display: block;
        font-size: 18px;
        font-family: Manrope Bold;
        color: #231c37;
        margin-bottom: 15px;
        text-decoration: underline;
        margin-top: 9px;
    }

    .teacher-item .teacher-description {
        font-size: 13px;
        line-height: 15px;
        max-width: 400px;
        margin: 0 auto;
    }

    .teacher-item .teacher-description:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(transparent 80%, white);
    }

    .teacher-item-foto, .owl-carousel .owl-item img.teacher-item-foto {
        border-radius: 50%;
        box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, 0.5);
        margin-bottom: 15px;
        width: 160px !important;
        height: 160px !important;
        object-fit: cover;
        max-width: 100%;
    }

</style>
